
















import { Prefix } from "@/types/debug-mode";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class PrefixesPopularAdd extends Vue {
  @Prop({ required: true })
  prefix!: Prefix;

  add(prefix: Prefix) {
    this.$ga.button("Add prefix (popular)");
    this.$store.dispatch("debugMode/addPrefix", prefix);
    // close the Add Prefix card
    this.$store.dispatch("debugMode/setShowAddPrefix", false);
  }
}
